import { useEffect, useRef, useState } from "react";
import { useAuth } from "context/AuthContext";
import TextInput from "components/ui/TextInput";
import useBodyScrollLock from "hooks/useBodyScrollLock";
import { callGetAcademyProfile, callUpdateAcademyProfile } from "api/MuyeonApi";

/**
 * 원장(ACADEMY) 유형으로 전환됐는데 학원명이 비어 있으면 입력 팝업.
 *  - 학원명은 profile.academyName 단일 소스 — 채용/대타공고 프리필·홈 추천 제목·공개 프로필에서 재사용.
 *  - 기존 modal-dimmed/.modal/tit-box/con-box/btn-group + TextInput 만 사용(새 CSS 없음).
 *  - "나중에" 선택 시 이번 세션에는 다시 묻지 않음.
 */
export default function AcademyNamePrompt() {
  const { activeType, auth } = useAuth();
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const dismissedRef = useRef(false); // 세션 내 1회만
  useBodyScrollLock(show);

  useEffect(() => {
    if (activeType !== "ACADEMY" || !auth?.accessToken || dismissedRef.current) return;
    let alive = true;
    callGetAcademyProfile()
      .then((r) => {
        if (!alive) return;
        const existing = (r.data?.academyName || "").trim();
        if (!existing) setShow(true);
      })
      .catch(() => {});
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeType, auth?.accessToken]);

  const close = () => { dismissedRef.current = true; setShow(false); };

  const save = async () => {
    const trimmed = name.trim();
    if (!trimmed || busy) return;
    setBusy(true);
    try {
      await callUpdateAcademyProfile({ academyName: trimmed });
      close();
    } catch (e) { /* 실패 시 팝업 유지 — 재시도 가능 */ }
    finally { setBusy(false); }
  };

  return (
    <div data-id="academy-name-prompt" className={`modal-dimmed ${show ? "is-show" : ""}`}>
      <div className="modal">
        <div className="tit-box"><p>학원명을 알려 주세요</p></div>
        <div className="con-box">
          <p className="t-body">
            공고 등록과 홈 추천에 쓰이는 이름이에요. 지금 등록해 두면 매번 입력하지 않아도 돼요.
          </p>
          <TextInput label="학원명" name="academyNamePrompt" isValid value={name}
            onChange={(e) => setName(e.target.value)} placeholder="예: 루체 발레 학원" maxLength={40} />
        </div>
        <div className="btn-group">
          <button type="button" className="btn-md outlined" onClick={close} disabled={busy}>나중에</button>
          <button type="button" className="btn-md filled primary" onClick={save}
            disabled={busy || !name.trim()}>저장</button>
        </div>
      </div>
    </div>
  );
}
